import React from 'react';
import GolfReservationCheckDetailTemplate from '../components/template/golfReservationCheckDetailTemplete';
import image_base from '../resources/image/GrandeeHamanako2.jpg';

class GolfReservationCheckDetail extends React.Component{
    constructor(props) {
        super(props);
        this.state = { 

        };
    };
    

    render(){
        return(
            <div style={style.base}>
                <GolfReservationCheckDetailTemplate />
            </div>
        )
    }
}

const style = {
    base: {
        backgroundImage: `url(${image_base})`,
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
    },
}

export default GolfReservationCheckDetail;